import OspreyAccountsSearch from './accounts-search'
import OspreyAccountsSearchSuggestion from './accounts-search-suggestion'
import OspreyAccountsMetadata from './accounts-metadata'
import OspreyAccountsStats from './accounts-stats'
import OspreyAccountsUpdate from './accounts-update'
import OspreyAccountsGetById from './accounts-get-by-id'
import OspreyAccountsUnactivated from './accounts-unactivated'

export default class Accounts {

    search(dataKey) {
        return new OspreyAccountsSearch(dataKey)
    }

    getSearchSuggestion(dataKey) {
        return new OspreyAccountsSearchSuggestion(dataKey)
    }

    getMetadata() {
        return new OspreyAccountsMetadata()
    }

    getStats() {
        return new OspreyAccountsStats()
    }

    update(dataKey) {
        return new OspreyAccountsUpdate(dataKey)
    }

    getById(dataKey) {
        return new OspreyAccountsGetById(dataKey)
    }

    getUnactivated(dataKey) {
        return new OspreyAccountsUnactivated(dataKey)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/index.js